/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sharemorelinks2Inputs */

const en_sharemorelinks2 = /** @type {(inputs: Sharemorelinks2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More links (${i?.count})`)
};

const de_sharemorelinks2 = /** @type {(inputs: Sharemorelinks2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weitere Links (${i?.count})`)
};

/**
* | output |
* | --- |
* | "More links ({count})" |
*
* @param {Sharemorelinks2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharemorelinks2 = /** @type {((inputs: Sharemorelinks2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharemorelinks2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharemorelinks2(inputs)
	return de_sharemorelinks2(inputs)
});
export { sharemorelinks2 as "shareMoreLinks" }